import React from 'react'
import './basic-dropdown.css'
import Select from 'react-select'

const BasicDropdown = ({
  disabled,
  className,
  multi,
  style,
  noMarginBottom,
  defaultValue,
  ...rest
}) => {

  const classes =
  `text-sm ${noMarginBottom ? '' : 'mb-4'} ${className}`

  const styles = {
    control: () => ({
      borderColor: '#ddd',
    }),
    ...style
  }

  return (
    <Select
      isMulti={multi}
      className={classes}
      isDisabled={disabled}
      style={styles}
      defaultValue={defaultValue}
      {...rest}
    />
  )
}

export { BasicDropdown }